export default "__VITE_ASSET__DhkOYYF4__"